import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {PortalAuthService} from '@portal-commons/portal-auth.service';
import {KeycloakService} from '@portal-commons/providers/keycloak.service';
import {Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';

@Injectable()
export class IsAnonymousGuard {
  constructor(
    private auth: PortalAuthService,
    private router: Router,
    private keycloakService: KeycloakService,
  ) {}

  canActivateChild(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    const urlTree = this.router.parseUrl(state.url);
    const primarySegments = urlTree.root.children['primary']?.segments ?? [];
    const isLoginRoot = primarySegments.length === 1 && primarySegments[0].path === 'login';
    const hasErrorParam = urlTree.queryParams['error'] != null;

    return this.auth.isAuthenticated().pipe(
      map((isAuthenticated: boolean) => {
        if (isAuthenticated) {
          return this.router.createUrlTree(['/']);
        }
        if (isLoginRoot && !hasErrorParam) {
          this.keycloakService.login(state.url);
          return false;
        }
        return true;
      }),
      catchError(() => of(true)),
    );
  }
}
